import { render, staticRenderFns } from "./basicDataSummarys.vue?vue&type=template&id=77d74f2a&"
import script from "./basicDataSummarys.vue?vue&type=script&lang=js&"
export * from "./basicDataSummarys.vue?vue&type=script&lang=js&"
import style0 from "./basicDataSummarys.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports